import React, { useState, useEffect, useRef } from 'react';
import SubscriberHeader from '../Dashboard/components/Header/Header';
import './UsageAnalysis.css';
import YourPlan from './components/YourPlan';
import SubscriberInfoBar from './components/SubscriberInfoBar/SubscriberInfoBar';
import { useAuth } from '../../../contexts/AuthContext';
import axios from 'axios';
import { getScenarioContent, getTemplatePrefix } from '../Constants/paymentScenarios';

const userInfo = {
  name: "Herman Hoff",
  accountNumber: "92550111078",
  email: "joy1103@yahoo.com",
  address: "302 TEAKWOOD DR 294889529 SC",
  accounts: [
    { value: "92554171828", label: "herm1" },
    { value: "92554171829", label: "herm2" },
  ],
};

const UsageAnalysis = ({ activeData }) => {
  const { token } = useAuth();
  
  const paymentScenario = activeData || null;
  console.log('UsageAnalysis - Received paymentScenario:', paymentScenario);

  // Use constants instead of hardcoded logic
  const scenarioContent = getScenarioContent(paymentScenario);
  const scenarioPrefix = getTemplatePrefix(paymentScenario);

  console.log('UsageAnalysis activeData:', activeData);
  console.log('UsageAnalysis scenarioPrefix:', scenarioPrefix);

  // State for toggles - matching Dashboard pattern
  const [toggles, setToggles] = useState({
    usageHeader: true,
    usageGraph: true,
  });

  const [templates, setTemplates] = useState([]);
  const [blockStates, setBlockStates] = useState({});
  const [supportBlockStates, setSupportBlockStates] = useState({});
  const triggerSaveData = useRef(false);
  const [reloadTemplates, setReloadTemplates] = useState(false);

  // Additional UsageAnalysis specific state
  const [selectedAccount, setSelectedAccount] = useState(userInfo.accounts[0].value);
  const [usageType, setUsageType] = useState("internet");

  // Template name logic with scenario prefix - matching Dashboard pattern
  const template_name = scenarioPrefix === 'current-payment' 
    ? 'gardenwall-usageAnalysis' 
    : `gardenwall-usageAnalysis-${scenarioPrefix}`;
    
  console.log('UsageAnalysis Template name:', template_name);

  const handleBlockStatesChange = (newBlockStates) => {
    setBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  const handleSupportBlockStatesChange = (newBlockStates) => {
    setSupportBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  // Function to toggle on/off switches - matching Dashboard
  const handleToggle = (section) => {
    setToggles((prev) => ({ ...prev, [section]: !prev[section] }));
    triggerSaveData.current = true;
  };

  // Auto-save trigger - matching Dashboard pattern
  useEffect(() => {
    if (triggerSaveData.current) {
      saveData();
      triggerSaveData.current = false;
    }
  }, [toggles, blockStates, supportBlockStates]);

  // Fetch templates function - matching Dashboard
  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    }
  };

  // Load templates on mount - matching Dashboard
  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates);
    };

    loadTemplates();
  }, []);

  // Reload templates effect - matching Dashboard
  useEffect(() => {
    if (reloadTemplates) {
      const loadTemplates = async () => {
        const fetchedTemplates = await fetchTemplates();
        setTemplates(fetchedTemplates);
        setReloadTemplates(false);
      };
  
      loadTemplates();
    }
  }, [reloadTemplates]);

  // Apply template data when templates are loaded - matching Dashboard
  useEffect(() => {
    if (templates && templates.length > 0) {
      console.log('UsageAnalysis Templates updated:', templates);
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate) {
        try {
          const template_data = JSON.parse(
            JSON.parse(specificTemplate.template)
          );
          setToggles(template_data.toggles || {
            usageHeader: true,
            usageGraph: true,
          });
          setBlockStates(template_data.blockStates || {});
          setSupportBlockStates(template_data.supportBlockStates || {});
          
          // Restore UsageAnalysis specific state if saved
          if (template_data.selectedAccount) {
            setSelectedAccount(template_data.selectedAccount);
          }
          if (template_data.usageType) {
            setUsageType(template_data.usageType);
          }
        } catch (error) {
          console.error('Error parsing template data:', error);
        }
      } else {
        console.log('UsageAnalysis specific template not found');
      }
    }
  }, [templates, template_name]);

  // Save data function - matching Dashboard pattern
  const saveData = async () => {
    const formData = new FormData();
    formData.append('template_name', template_name);
    formData.append(
      'template',
      JSON.stringify({
        toggles,
        blockStates,
        supportBlockStates,
        scenarioData: paymentScenario,
        selectedAccount,
        usageType
      })
    );
    
    console.log('UsageAnalysis - Saving template with name:', template_name);

    const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
    let url = `${urlBase}/create`;
    let method = 'post';

    if (templates && templates.length > 0) {
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate && specificTemplate.id) {
        url = `${urlBase}/update/${specificTemplate.id}`;
        method = 'put';
      }
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      console.log('UsageAnalysis Response Data:', response.data); 
      if (method === 'post') {
        setReloadTemplates(true);
      }

    } catch (error) {
      console.error('Error saving usage analysis template:', error);
    }
  };

  return (
    <div className="subscriberConnect-container">
      {/* Usage Analysis Header with Payment Scenario Status */}
      <h1 className="usage-analysis-header">
        Usage Analysis – <span className={scenarioContent.headerClass}>{scenarioContent.headerStatus}</span>
      </h1>

      <div className="usage-analysis-grid">
        {/* Usage Analysis Header Card */}
        <div className={`card col-4 your-plan ${!toggles.usageHeader ? 'card-disabled' : ''}`}>
          <div className="card-header">
            Usage Analysis Header
            <div className="custom-toggle" onClick={() => handleToggle('usageHeader')}>
              <input type="checkbox" checked={toggles.usageHeader} readOnly />
              <span className="toggle-slider"></span>
            </div>
          </div>
          <SubscriberInfoBar
            name={userInfo.name}
            accountNumber={userInfo.accountNumber}
            email={userInfo.email}
            address={userInfo.address}
            scenarioData={paymentScenario}
            onBlockStatesChange={handleBlockStatesChange}
            blockStates={blockStates}
          >
            <select 
              className="usage-select" 
              value={usageType} 
              onChange={e => {
                setUsageType(e.target.value);
                triggerSaveData.current = true;
              }}
            >
              <option value="internet">Internet usage</option>
              <option value="call">Call usage</option>
              <option value="sms">SMS usage</option>
            </select>
            <select 
              className="account-select" 
              value={selectedAccount} 
              onChange={e => {
                setSelectedAccount(e.target.value);
                triggerSaveData.current = true;
              }}
            >
              {userInfo.accounts.map(acc => (
                <option key={acc.value} value={acc.value}>
                  {acc.value} - {acc.label}
                </option>
              ))}
            </select>
          </SubscriberInfoBar>
        </div>

        {/* Usage Analysis Graph Card */}
        <div className={`card col-4 your-plan ${!toggles.usageGraph ? 'card-disabled' : ''}`}>
          <div className="card-header">
            Usage Analysis Graph
            <div className="custom-toggle" onClick={() => handleToggle('usageGraph')}>
              <input type="checkbox" checked={toggles.usageGraph} readOnly />
              <span className="toggle-slider"></span>
            </div>
          </div>
          <YourPlan 
            scenarioData={paymentScenario}
            onBlockStatesChange={handleBlockStatesChange}
            blockStates={blockStates}
            selectedAccount={selectedAccount}
            usageType={usageType}
          />
        </div>
      </div>
    </div>
  );
};

export default UsageAnalysis;

